export type ContactRequestMessages = {
  contactCreateError: string;
  contactUpdateError: string;
  contactCreateSuccess: string;
  contactUpdateSuccess: string;
  tagCreateError: string;
  tagCreateSuccess: string;
};

export const CONTACT_REQUEST_MESSAGES: ContactRequestMessages = {
  contactCreateSuccess: "Contato criado com sucesso!",
  contactUpdateSuccess: "Contato atualizado com sucesso!",
  contactCreateError: "Erro na criação do contato!",
  contactUpdateError: "Erro ao salvar o contato!",
  tagCreateSuccess: "Tag criada com sucesso!",
  tagCreateError: "Erro na criação da tag!",
};
